var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRefreshIcon = function SvgRefreshIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7395 4.9927L11 4.9927V6.9927L17.987 6.99271L17.9869 0H15.9869L15.987 3.32704C15.2756 2.45086 14.3996 1.70867 13.3976 1.14756C11.4217 0.0409689 9.10116 -0.279997 6.89902 0.24869C4.69688 0.777376 2.77501 2.11685 1.5168 3.99989C0.258595 5.88293 -0.243446 8.1711 0.110833 10.4079C0.465112 12.6448 1.64967 14.6658 3.42818 16.0679C5.2067 17.4699 7.44843 18.15 9.70616 17.9723C11.9639 17.7946 14.0716 16.7723 15.6089 15.1092C16.686 13.9441 17.4275 12.5245 17.775 11H15.7105C14.8503 13.8921 12.1714 16.0012 9 16.0012C5.13401 16.0012 2 12.8672 2 9.00116C1.99999 8.96415 2.00029 8.92714 2.00087 8.89016C2.02324 7.4508 2.48005 6.11687 3.24594 5.01373C3.7963 4.21927 4.50055 3.5539 5.30919 3.0521C6.06039 2.58506 6.90655 2.25635 7.81206 2.10155C8.60259 1.96539 9.40591 1.96695 10.1874 2.10146C11.0804 2.25404 11.9156 2.57574 12.659 3.03244C13.4853 3.53906 14.1918 4.20826 14.7395 4.9927Z",
    fill: "#220C4A"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRefreshIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/refresh-icon.75cc09f9.svg";
export { ForwardRef as ReactComponent };